'use strict';

const { getDependencyClass } = require('../../lib/dependencies.js');
const basicAuth = require('../../lib/basicAuth');
const performanceMeasure = require('../../lib/performanceMeasure.js');
let measure = performanceMeasure('webcomponents:footerLoader');

getDependencyClass('phoenix-page').then((pageClass) => {
    /**
     * PhoenixFooterLoader is a web component responsible for listenening
     * to clicks on the "SEE MORE" button and emitting an event for other
     * web components when clicked.
     *
     *
     * @example
     *  <phoenix-footer-loader>
     *      <button>
     *          <div>Loading</div>
     *          <div>See More</div>
     *      </button>
     *  </phoenix-footer-loader>
     */

    class PhoenixFooterLoader extends pageClass.PhoenixElement {
        get link() {
            return this.getAttribute('footer-link');
        }

        connectedCallback() {
            super.connectedCallback();
            this.waitForElement('button').then((button) => {
                this.button = button;
                this.button.addEventListener(
                    'click',
                    () => this.onClick(),
                    pageClass.util.supportPassiveEventListeners() ? { passive: true } : false
                );
            });
        }

        onClick() {
            // navigate if we have a URL
            if (this.link) {
                window.location.href = this.link;
                return;
            }

            // 'load more' behavior is currently in a parent element, so emit event
            this.emitEvent('phoenix:footer:seeMore:click', {
                bubbles: true,
                detail: {
                    moreResultsToken: this.getAttribute('more-results-token'),
                },
            });
        }

        disconnectedCallback() {
            super.disconnectedCallback();
            this.removeEventListener('click', this.onClick);
        }
    }

    window.customElements.define('phoenix-footer-loader', PhoenixFooterLoader);
    measure.end();
});
